import { render, staticRenderFns } from "./MainProjectOffer.vue?vue&type=template&id=5ea5b70a&scoped=true&"
import script from "./MainProjectOffer.vue?vue&type=script&lang=js&"
export * from "./MainProjectOffer.vue?vue&type=script&lang=js&"
import style0 from "./MainProjectOffer.vue?vue&type=style&index=0&id=5ea5b70a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea5b70a",
  null
  
)

export default component.exports